const heightSpacePlugin: any = {
  Renderer: ({ data }: any) => (
    <div className="space-height" style={{ height: data?.height }} />
  ),

  id: 'heightSpacePlugin',
  title: 'Height Space',
  // description: 'emergency content plugin',
  version: 1,
  controls: {
    type: 'autoform',
    schema: {
      // required: ['backgroundColor'],
      properties: {
        height: { type: 'number', default: 50 },
      },
    },
  },
};

export default heightSpacePlugin;
